export default "__VITE_ASSET__MU7yQ9f8__"